import { localStorageBoolean } from "@/utils/constants";

export default {
  namespaced: true,

  state() {
    return {
      isProspectAuthenticated: false,
      preProspectSession: false,
    };
  },

  getters: {},
  mutations: {
    initialise: (state: any) => {
      if (localStorage.getItem("isProspectAuthenticated")) {
        state.isProspectAuthenticated = true;
      }
    },
    SET_PROSPECT_AUTHENTICATED: (state: any) => {
      state.isProspectAuthenticated = true;
      localStorage.setItem("isProspectAuthenticated", localStorageBoolean.true);
    },
    SET_PROSPECT_UNAUTHENTICATED: (state: any) => {
      state.isProspectAuthenticated = false;
      localStorage.removeItem("isProspectAuthenticated");
    },
    SET_PRE_PROSPECT_SESSION: (state: any) => {
      state.preProspectSession = true;
    },
    UNSET_PRE_PROSPECT_SESSION: (state: any) => {
      state.preProspectSession = false;
    },
  },
  actions: {
    authenticateProspect: ({ commit }) => {
      commit("SET_PROSPECT_AUTHENTICATED");
    },
    unauthenticateProspect: ({ commit }) => {
      commit("SET_PROSPECT_UNAUTHENTICATED");
    },
    setPreProspectSession: ({ commit }) => {
      commit("SET_PRE_PROSPECT_SESSION");
    },
    unsetPreProspectSession: ({ commit }) => {
      commit("UNSET_PRE_PROSPECT_SESSION");
    },
  },
};
